import { RESTClient } from "fmko-ts-common";
import { CertTestCaseVO, CertTestGroupVO, CertTestGroupsVO, CertTestRapportVO, CertTestVO, WhitelistingVO } from "./RestTypes";
import CertTestAdminApp from "./CertTestAdminApp";

export default class CertTestService {
    static instance: CertTestService;

    baseUrl: string;
    systeminfoUrl: string;
    restClient = new RESTClient({ version: undefined });


    public static getInstance(): CertTestService {
        if (!this.instance) {
            // var baseUrl = mod.mc().getConfiguration().getMinlogUrlBase();
            let baseUrl = "/fmk12/certtestrest/certtest";
            let systeminfoUrl = "/fmk12/certtestrest/systeminfo";
            this.instance = new CertTestService(baseUrl, systeminfoUrl);
        }

        return this.instance;
    }

    constructor(baseUrl: string, systeminfoUrl: string) {
        this.baseUrl = baseUrl;
        this.systeminfoUrl = systeminfoUrl;
    }

    public async createCertTest(testName: string, testSet: string, selectedWhitelisting: WhitelistingVO): Promise<CertTestVO> {
        let url = this.baseUrl + "/" + testName + "/" + testSet + "?"
            + CertTestAdminApp.certTestPanel.selectedGroups.map(group => `testGroup=${group}`).join("&")
            + "&systemowner=" + selectedWhitelisting.systemOwnerName
            + "&systemname=" + selectedWhitelisting.systemName
            + "&systemversion=" + encodeURIComponent(selectedWhitelisting.systemVersion);

        CertTestAdminApp.clearAlert();

        return this.restClient.put<CertTestVO>(url, "Opretter certificeringstest", undefined, undefined);
    }

    public cloneCertTest(newName: string, oldName: string): Promise<CertTestVO> {
        let url = this.baseUrl + "/" + newName + "/cloneof/" + oldName;

        CertTestAdminApp.clearAlert();

        return this.restClient.put<CertTestVO>(url, "Kloner certificeringstest", undefined, undefined);
    }

    public getCertTest(testName: string): Promise<CertTestVO> {
        let url = this.baseUrl + "/" + testName;

        CertTestAdminApp.clearAlert();

        return this.restClient.get<CertTestVO>(url, "Henter certificeringstest");
    }

    public removeCertTest(testName: string) {
        let url = this.baseUrl + "/" + testName;

        CertTestAdminApp.clearAlert();

        return this.restClient.delete<CertTestVO>(url, undefined, "Sletter certificeringstest");
    }

    public updateTestCaseState(testName: string, testCaseId: string, action: string) {
        let url = this.baseUrl + "/" + testName + "/testcase/" + testCaseId + "/changestate/" + action;

        CertTestAdminApp.clearAlert();

        return this.restClient.post<CertTestCaseVO>(url, undefined, "Opdaterer test case");
    }

    public ignoreTestCase(testName: string, testCaseId: string, action: string, message: string) {
        let url;
        if (action === "ignore" && message.length > 0) {
            url = this.baseUrl + "/" + testName + "/testcase/" + testCaseId + "/ignore/" + message;
        } else {
            url = this.baseUrl + "/" + testName + "/testcase/" + testCaseId + "/changestate/" + action;
        }

        CertTestAdminApp.clearAlert();

        return this.restClient.post<CertTestCaseVO>(url, undefined, "Ignorer test case");
    }

    public updateTestCaseParam(testName: string, testCaseId: string, param: string, value: string) {
        let url = this.baseUrl + "/" + testName + "/testcase/" + testCaseId + "/setparam/" + param + "/" + value;

        CertTestAdminApp.clearAlert();

        return this.restClient.post<CertTestCaseVO>(url, undefined, "Opdaterer test case");
    }

    public getCertTestGroups() {
        let url = this.baseUrl + "/testgroups";

        CertTestAdminApp.clearAlert();

        return this.restClient.get<CertTestGroupsVO>(url, "Henter certificeringstest grupper");
    }

    public getCertTestGroup(groupid: string, version: WhitelistingVO) {
        let url = this.baseUrl + "/testgroups/" + groupid + "/" + version.systemName + "/" + version.systemOwnerName + "/" + encodeURI(version.systemVersion);

        CertTestAdminApp.clearAlert();

        return this.restClient.get<CertTestGroupVO>(url, "Henter tests i gruppe");
    }

    public getTestRapport(testid: string) {
        let url = this.baseUrl + "/" + testid + "/requests";

        CertTestAdminApp.clearAlert();

        return this.restClient.get<CertTestRapportVO>(url, "Henter rapport for test");
    }
}
